
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-two-maids",
      function () {
        return require("private-next-pages/why-two-maids.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/why-two-maids"])
      });
    }
  